import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React, { lazy, useState } from 'react';
import { FormStateChangeNotifier } from '../form';
var styles = css({
  lineHeight: '20px'
});
var AKCheckbox = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.checkbox' */
  '@atlaskit/checkbox').then(function (module) {
    return {
      default: module.Checkbox
    };
  });
});
var AKCheckboxField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.CheckboxField
    };
  });
});
var Fieldset = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Fieldset
    };
  });
});
var AKHelperMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var CheckboxGroup = function CheckboxGroup(_ref) {
  var options = _ref.options,
    label = _ref.label,
    name = _ref.name,
    description = _ref.description;
  var defaultValues = [];
  options.forEach(function (option) {
    if (option.defaultChecked) {
      defaultValues.push(option.value);
    }
  });
  var _useState = useState(defaultValues),
    _useState2 = _slicedToArray(_useState, 2),
    checkboxFieldValues = _useState2[0],
    setCheckboxFieldValues = _useState2[1];
  return jsx(Fieldset, {
    legend: label
  }, description && jsx(AKHelperMessage, null, description), options.map(function (option) {
    var key = option.key,
      label = option.label,
      value = option.value,
      defaultChecked = option.defaultChecked,
      isRequired = option.isRequired;
    return jsx(AKCheckboxField, {
      key: key,
      value: value,
      defaultIsChecked: defaultChecked,
      name: name
    }, function (_ref2) {
      var fieldProps = _ref2.fieldProps;
      var id = fieldProps.id,
        isDisabled = fieldProps.isDisabled,
        isInvalid = fieldProps.isInvalid,
        _onChange = fieldProps.onChange,
        onBlur = fieldProps.onBlur,
        onFocus = fieldProps.onFocus,
        value = fieldProps.value,
        name = fieldProps.name,
        ariaInvalid = fieldProps['aria-invalid'],
        ariaLabelledBy = fieldProps['aria-labelledby'],
        isChecked = fieldProps.isChecked;
      return jsx("div", {
        css: styles
      }, jsx(AKCheckbox, {
        id: id,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onBlur: onBlur,
        onFocus: onFocus,
        value: value,
        name: name,
        label: label,
        onChange: function onChange(e) {
          if (e.target.checked) {
            setCheckboxFieldValues(function (prevState) {
              return [].concat(_toConsumableArray(prevState), [value]);
            });
          } else {
            setCheckboxFieldValues(checkboxFieldValues.filter(function (e) {
              return e !== value;
            }));
          }
          return _onChange(e);
        },
        "aria-invalid": ariaInvalid,
        "aria-labelledby": ariaLabelledBy
      }));
    });
  }), jsx(FormStateChangeNotifier, {
    name: name,
    value: checkboxFieldValues
  }));
};

// NOTE: use `label` instead

var CheckboxGroupFn = function CheckboxGroupFn(_ref3) {
  var propsAny = _ref3.props,
    children = _ref3.children;
  var _ref4 = propsAny,
    name = _ref4.name,
    description = _ref4.description;
  var props = propsAny;

  // NOTE: legend is deprecated
  var label = 'legend' in props ? props.legend : props.label;
  var options = children.filter(function (_ref5) {
    var type = _ref5.type;
    return type === 'Checkbox';
  }).map(function (child) {
    var key = child.key,
      props = child.props;
    var _ref6 = props,
      label = _ref6.label,
      value = _ref6.value,
      defaultChecked = _ref6.defaultChecked,
      isRequired = _ref6.isRequired;
    return {
      key: key,
      label: label,
      value: value,
      defaultChecked: defaultChecked,
      isRequired: isRequired
    };
  });
  return jsx(CheckboxGroup, {
    label: label,
    name: name,
    options: options,
    description: description
  });
};
export { CheckboxGroup, CheckboxGroupFn };